import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="main-footer d-flex">
      <div className="float-right d-none d-sm-block">
        <b>Version</b> 5.5
      </div>
      <strong>
        Copyright © 2020
        <Link to="/home-dashboard" className="text-danger">
          TRULY NOLEN
        </Link>
        .
      </strong>
      All rights reserved.
    </footer>
  );
};
